<template>
  <div class="confirm">
    <v-btn
      class="mr-2"
      depressed
      color="primary"
      @click="confirm"
    >
      {{ confirmText }}
    </v-btn>
    <v-btn
      depressed
      color="secondary"
      @click="cancel"
    >
      {{ rejectText }}
    </v-btn>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    confirmText: {
      type: String,
      default: 'Tak',
    },
    rejectText: {
      type: String,
      default: 'Nie',
    },
  },

  methods: {
    ...mapActions('dialog', [
      'confirm',
      'cancel',
    ]),
  },
};
</script>
